// Format a Date as a local-timezone Y-M-D string (e.g. "2026-06-12").
//
// IMPORTANT: do NOT use `date.toISOString().split("T")[0]` for calendar dates.
// `toISOString()` converts to UTC, so a local-midnight Date in a positive-offset
// timezone (UK BST, EU, AU, NZ) rolls back to the previous calendar day. That
// off-by-one caused hosts east of UTC to block/set the wrong availability date.
export function toLocalISODate(d: Date): string {
  const yyyy = d.getFullYear();
  const mm = String(d.getMonth() + 1).padStart(2, "0");
  const dd = String(d.getDate()).padStart(2, "0");
  return `${yyyy}-${mm}-${dd}`;
}
